import BasePolicy from '@/policies/BasePolicy.js';

export default class StatusPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all statuses';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, status) {
        const permission = 'view a status';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a status';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    update(user, status) {
        const permission = 'update a status';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a status';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }
}
